import React from "react";
import { ExtractGroup, ExtractConfig } from "../../../types/extract.types";
import styles from "./ExtractionOptionsSectionView.module.scss";

export interface ExtractionOptionsSectionViewProps {
  selectedGroup: ExtractGroup | null;
  selectedExtract: ExtractConfig | null;
  onExtractSelect: (extract: ExtractConfig) => void;
}

export default function ExtractionOptionsSectionView({
  selectedGroup,
  selectedExtract,
  onExtractSelect,
}: ExtractionOptionsSectionViewProps) {
  return (
    <div className={styles["extraction-options"]}>
      <div className={styles["extraction-options__header"]}>
        <span className={styles["extraction-options__badge"]}>2</span>
        <h2 className={styles["extraction-options__title"]}>Options d'extraction</h2>
      </div>

      {selectedGroup ? (
        <>
          <div className={styles["extraction-options__tabs"]}>
            {selectedGroup.extracts.map((extract) => (
              <button
                key={extract.id}
                className={`${styles["extraction-options__tab"]} ${
                  selectedExtract?.id === extract.id
                    ? styles["extraction-options__tab--active"]
                    : ""
                }`}
                onClick={() => onExtractSelect(extract)}
              >
                {extract.name}
              </button>
            ))}
          </div>

          {selectedExtract && (
            <div className={styles["extraction-options__fields-section"]}>
              <p className={styles["extraction-options__fields-label"]}>
                Colonnes à extraire
              </p>
              <div className={styles["extraction-options__fields"]}>
                {selectedExtract.fields.map((field) => (
                  <span
                    key={field.key}
                    className={styles["extraction-options__field-tag"]}
                  >
                    {field.label}
                  </span>
                ))}
              </div>
            </div>
          )}
        </>
      ) : (
        <p className={styles["extraction-options__placeholder"]}>
          Sélectionnez un type de device pour voir les options d'extraction.
        </p>
      )}
    </div>
  );
}
